import { render, staticRenderFns } from "./OwnersTable.vue?vue&type=template&id=7c04e321&"
import script from "./OwnersTable.vue?vue&type=script&lang=js&"
export * from "./OwnersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports